import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Link, Paper, TextField, Typography } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { ReactComponent as TesseraSanitaria } from "../../resources/icone/fiscalCode.svg";
import images from "../../resources/export";
import { Redirect } from "../tools/Redirect";
import { POSTLOGINLANDING } from "../../global/urlMapping";
import { AuthComp } from "../../auth/AuthComp";
import { validateCF, validateTS } from "../../functions/inputValidation";
import { useDispatch, useSelector } from "react-redux";
import { crypt, urlLogin } from "../../auth/authFunctions";
import { postLoginAction } from "../../modules/postLogin/actions";
import { generaLog } from "../../functions/utils";
import { authTypeSelector } from "../../modules/auth/selectors";
import Cookies from 'js-cookie';
import { leggiValori } from "../../api/apiSession";

export const Login = () => {
    const dispatch = useDispatch()
    const [TNS, setTNS] = useState({ value: "", error: false, messageError: "" });
    const [CF, setCF] = useState({ value: "", error: false, messageError: "" });
    const handleChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case "cf":
                const valueUpper = value.toUpperCase();
                setCF(validateCF(valueUpper))
                break;
            case "tns":
                setTNS(validateTS(value))
                break;
            default:
                break;
        }
    }

    const onClickLoginCfTns = (cf, tns) => {
        sessionStorage.clear()
        generaLog("Login CF", "log")
        sessionStorage.setItem("tempCFTNS", crypt(cf + ":" + tns));
        sessionStorage.setItem("expirationDate", new Date().getTime() + 60000);
        dispatch(postLoginAction())
    }

    useEffect(() => {
        window.scrollTo(0, 0)

        //LOGIN SALUTESIMPLEX
        const urlParams = new URLSearchParams(window.location.search)
        const codiceFiscale = urlParams.get('cf') ?? urlParams.get('CF');
        const tesseraSanitaria = urlParams.get('ts') ?? urlParams.get('TS')
        if (codiceFiscale !== null && codiceFiscale !== undefined &&
            tesseraSanitaria !== null && tesseraSanitaria !== undefined) {
            setCF({ value: codiceFiscale, error: false, messageError: "" })
            setTNS({ value: tesseraSanitaria, error: false, messageError: "" })

            // eseguo login solo se sono entrambi non nulli o non vuoti
            if (codiceFiscale?.length > 0 && tesseraSanitaria?.length > 0) {
                onClickLoginCfTns(codiceFiscale, tesseraSanitaria)
            }
        }
        else {
            leggiValori().then((res) => {
                setCF({ value: res?.data?.cf, error: false, messageError: "" })
                setTNS({ value: res?.data?.tessera, error: false, messageError: "" })
                if (res?.data?.cf && res?.data?.cf?.length > 0 && res?.data?.tessera && res?.data?.tessera?.length > 0) {
                    onClickLoginCfTns(res?.data?.cf, res?.data?.tessera)
                }

            }).catch((err) => {
                console.log(err)
            })
        }
    }, [])


    return (
        <AuthComp
            fallback={

                <Box
                    sx={{
                        backgroundColor: "transparent",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box sx={{ x: 'auto' }}>
                        <Grid container wrap="nowrap" spacing={2}>
                            <Grid item xs zeroMinWidth>

                                <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                    <Typography
                                        component='h1'
                                        sx={{
                                            color: "#005397",
                                            margin: "auto",
                                            textAlign: "center",
                                            fontSize: { xs: "25px", md: "40px" },
                                            fontWeight: 700,
                                        }}
                                    >
                                        Accedi con SPID o con Codice Fiscale
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box
                        sx={{
                            width: "100%",
                            height: "600px",
                            display: "flex",
                            margin: "auto",
                            flexDirection: { xs: "column", md: "row" },
                        }}
                    >
                        <Paper
                            elevation={6}
                            sx={{
                                borderRadius: "20px",
                                margin: "auto",
                                width: { xs: "80%", md: "450px" },
                                height: { xs: "150px", md: "550px" },
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <Box sx={{ height: '100%', width: '100%', backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', }}>
                                <Typography

                                    sx={{
                                        color: "#005397",
                                        fontWeight: 600,
                                        marginTop: "10px",
                                        fontSize: { xs: "15px", md: "20px" },
                                        textAlign: "center",
                                    }}
                                >
                                    SPID
                                </Typography>
                                <Box sx={{ height: "100%", display: { xs: "none", md: "flex" }, flexDirection: "column" }}>
                                    <Typography component={'span'} sx={{ width: "90%", margin: "10px auto", textAlign: "left", wordWrap: "break-word" }}>
                                        SPID è il sistema di accesso che consente di utilizzare, con un'identità digitale unica, i servizi
                                        online della Pubblica Amministrazione e dei privati accreditati.
                                    </Typography>

                                    <Typography component={'span'} sx={{ width: "90%", margin: "10px auto", textAlign: "left", wordWrap: "break-word" }}>
                                        Se sei già in possesso di un'identità digitale, accedi con le credenziali del tuo gestore.
                                    </Typography>

                                    <Typography component={'span'} sx={{ width: "90%", margin: "10px auto", textAlign: "left", wordWrap: "break-word" }}>
                                        Se non hai ancora un'identità digitale, richiedila ad uno dei gestori.
                                    </Typography>

                                    <Link
                                        sx={{ width: "90%", margin: "10px auto", textAlign: "left", wordWrap: "break-word" }}
                                        href={"https://www.spid.gov.it/"}
                                    >
                                        Maggiori info
                                    </Link>

                                    <Link
                                        sx={{ width: "90%", margin: "5px auto", textAlign: "left", wordWrap: "break-word" }}
                                        href={"https://www.spid.gov.it/cos-e-spid/"}
                                    >
                                        Non hai spid?
                                    </Link>

                                    <Box
                                        sx={{
                                            width: "90%",
                                            margin: "20px auto",
                                            display: "flex",
                                            flexDirection: { xs: "column", md: "row" },
                                        }}
                                    >
                                        <img src={images.loghi.logoSpid} style={{ margin: "auto 0" }} alt="logo-spid" />
                                        <img src={images.loghi.logoAgid} style={{ margin: "auto" }} alt="logo-AgID" />
                                    </Box>
                                </Box>
                                <Link
                                    sx={{
                                        backgroundColor: "#06c !important",
                                        borderRadius: "4px",
                                        color: "white",
                                        height: "60px",
                                        width: "90%",
                                        margin: { xs: "auto", md: "20px auto" },
                                        display: "flex", justifyContent: "center", alignContent: "center",
                                    }}
                                    href={urlLogin}>

                                    <Box
                                        sx={{ display: "flex", alignSelf: "center" }}
                                    >
                                        <AccountCircle sx={{ color: "white", marginRight: "10px" }} />

                                        <Typography component={'span'} sx={{ fontSize: "15px", color: "white", fontWeight: 600 }}>Entra con SPID</Typography>
                                    </Box>


                                </Link>

                            </Box>
                        </Paper>

                        <Paper elevation={6} sx={{ borderRadius: '20px', margin: 'auto', width: { xs: '80%', md: '450px' }, height: { xs: '300px', md: '550px' }, display: 'flex', flexDirection: 'column' }}>
                            <Box sx={{ height: '100%', width: '100%', backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', }}>
                                <Typography
                                    sx={{
                                        color: "#005397",
                                        fontWeight: 600,
                                        marginTop: "10px",
                                        fontSize: { xs: "15px", md: "20px" },
                                        textAlign: "center",
                                    }}
                                >
                                    Codice Fiscale
                                </Typography>
                                <Box sx={{ height: '100%', width: '90%', backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', margin: '0 auto' }}>
                                    <TextField
                                        id="textFieldCF"
                                        error={CF.error}
                                        helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                            {CF.messageError}
                                        </Typography>}
                                        value={CF.value}
                                        name="cf"
                                        onChange={handleChange}
                                        label="Codice Fiscale"
                                        autoFocus
                                        sx={{ maxWidth: '90%', width: '90%', margin: 'auto' }}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        autoComplete="off"
                                    />

                                    <TextField
                                        id="textFieldTns"
                                        error={TNS.error}
                                        helperText={<Typography component={'span'} sx={{ wordWrap: 'break-word', fontWeight: 600 }}>
                                            {TNS.messageError}
                                        </Typography>}
                                        value={TNS.value}
                                        name="tns"
                                        onChange={handleChange}
                                        label="Ultime 5 cifre Tessera Sanitaria"
                                        sx={{ maxWidth: '90%', width: '90%', margin: 'auto' }}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        autoComplete="off"
                                    />

                                </Box>
                                <Button disableRipple disableTouchRipple disableFocusRipple
                                    id="entraConCF"
                                    onClick={() => onClickLoginCfTns(CF.value, TNS.value)}
                                    sx={{ backgroundColor: '#06c !important', borderRadius: '4px', color: 'white', height: '60px', width: '90%', margin: '20px auto' }}>
                                    <TesseraSanitaria style={{ marginRight: '10px', height: "60%" }} />
                                    <Typography component={'span'} sx={{ fontSize: '15px', color: 'white', fontWeight: 600, textTransform: "none" }}>
                                        Entra con il Codice Fiscale
                                    </Typography>
                                </Button>
                            </Box>
                        </Paper>
                    </Box>
                </Box >
            }
        >
            <Redirect link={POSTLOGINLANDING} />
        </AuthComp >
    );
};